/**Dependencies */
import "antd/dist/antd.less";
import "./assets/css/fonts.css";
import "./assets/css/override.css";
import "./assets/css/variables.css";
import './locale/i18n';

import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

import { App } from "./App";
import { BrowserRouter } from "react-router-dom";
import { JulebProvider } from "./context";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <JulebProvider>
    <BrowserRouter basename="support">
      <App />
    </BrowserRouter>
  </JulebProvider>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
